iScreenWizard.factory('Testsoort', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('testsoort').then(function (response) {
                var testsoorten = response.data;
                resolve(testsoorten);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('testsoort/'+id).then(function (response) {
                var testsoort = response.data;
                resolve(testsoort);
            }, reject);
        });
    };

    return data;
});